module.exports = __webpack_public_path__ + "img/shipin.e549a0f7.jpg";